import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const ScheduledJobLogListTemplate = ({
	t,
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
	},
	headerCell,
	actions,
}) => {
	return (
		<section>
			<div className="alerts-page__search">
				<div className="alerts-page__search-field">
					<input
						className="input"
						type="text"
						placeholder={t('SEARCH')}
						value={viewStore.searchText}
						onChange={e => viewStore.setSearchText(e.target.value)}
					/>
					{viewStore.searchText.length > 0 && (
						<span className="input__clear" onClick={() => viewStore.setSearchText('')}></span>
					)}
				</div>
			</div>
			{viewStore.loading ? (
				<Loader />
			) : (
				<BaasicTable
					{...{
						listStore,
						tableData,
						queryUtility,
						viewStore,
						headerCell,
						actions,
					}}
					data={viewStore.getFilteredData()}
					rowRender={ScheduledJobLogCustomRowRender} // red background if job has errors
				/>
			)}
		</section>
	);
};

function ScheduledJobLogCustomRowRender(trElement, { dataItem }) {
	let className = trElement.props.className;
	// const hasErrors = dataItem.errors && dataItem.errors.length > 0;
	// if (hasErrors) {
	// 	className = trElement.props.className + ' is-warning';
	// } else {
	// 	className = trElement.props.className;
	// }
	return <tr className={className}>{trElement.props.children}</tr>;
}

export default defaultTemplate(ScheduledJobLogListTemplate);
